import {
  Box,
  Button,
  CardContent,
  CardHeader,
  Checkbox,
  Container,
  Divider,
  FormControlLabel,
  Grid,
  Switch,
  TextField,
  Typography
} from '@mui/material';
import { ChangeEvent, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { checkAutoLogin } from '../../Login/auth-reducer';
import { getProjectNamesFromCookies, setCurrentLocation } from '../../../app/cookies';
import { AppRootState } from '../../../app/store';
import { createNewUserTC, UserType, setIsNewAccount } from '../users-reducer';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { createNewUserForNewAccountTC } from '../../Accounts/New account/newAccount-reducer';

export const NewUserData = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const state = location.state as any
  console.log('STATE', state)
  let accountId: number
  state.account ? accountId = state.account.id : accountId = state.id
  console.log('accountId', accountId)
  let user: UserType = {
    id: 0,
    firstName: '',
    lastName: '',
    userName: '',
    email: '',
    description: '',
    isAdminRole: false,
    roles: [],
    tags: [],
    isActive: false,
    password: '',
    accountId: accountId,
    projects: [],
    rowVersion: ''
  }
  const isLoggedIn = useSelector<AppRootState, boolean>(state => state.auth.isLoggedIn)
  const isNewAccount = useSelector<AppRootState, boolean>(state => state.users.isNewAccount)

  // const [projectName, setProjectName] = useState("")
  const [values, setValues] = useState({ ...user })
  const [checkbox, setCheckbox] = useState(user.isActive)
  let stateLabel
  user.isActive ? stateLabel = 'Active' : stateLabel = ''
  const [label, setLabel] = useState(stateLabel)
  const [err, setError] = useState(false)
  const [passwordErr, setpasswordErr] = useState(false)
  const [userNameErr, setuserNameErr] = useState(false)
  const [firstNameErr, setfirstNameErr] = useState(false)
  const [lastNameErr, setlastNameErr] = useState(false)
  const [emailErr, setemailErr] = useState(false)
  const [rolesErr, setrolesErr] = useState(false)
  const [personName, setPersonName] = useState<string[]>([]);

  const [unconfirmedPassword, setUnconfirmedPassword] = useState('')

  const [adminRole, setAdminRole] = useState(user.roles.includes("Administrator"))
  const [itRole, setITRole] = useState(user.roles.includes("IT"))
  const [serviceRole, setServiceRole] = useState(user.roles.includes("Servicedesk"))
  let newRoles = [] as Array<string>
  let rolesForSend: Array<string>
  newRoles[0] = adminRole ? "Administrator" : ""
  newRoles[1] = itRole ? "IT" : ""
  newRoles[2] = serviceRole ? "Servicedesk" : ""
  rolesForSend = newRoles.filter(role => role !== '')

  useEffect(() => {
    let token = checkAutoLogin(dispatch,false)
    if (!token && isLoggedIn === false) {
      return navigate('/login');
    }  else {
      if(token !== null && isLoggedIn === false){
        return navigate(`/accountsList`)
      }
    }
    return () => {
      setCurrentLocation(`\\ Accounts \\ New Account `)
      dispatch(setIsNewAccount(false))
    }
  }, [isLoggedIn]);

  const checkEmptyFields = () => {
    if (values.userName === '') {
      setuserNameErr(true)
    } else {
      if (values.password === '') {
        setpasswordErr(true)
      } else {
        if (values.firstName === '') {
          setfirstNameErr(true)
        } else {
          if (values.lastName === '') {
            setlastNameErr(true)
          } else {
            if (values.email === '') {
              setemailErr(true)
            } else {
              if (rolesForSend.length < 1) {
                setrolesErr(true)
              } else createNewUser()
            }
          }
        }
      }
    }
  }
  // const removeError = (fieldName: string) => {
  //   if (fieldName === 'userName') {
  //     setuserNameErr(false)
  //   } else {
  //     if (fieldName === 'password') {
  //       setpasswordErr(false)
  //     } else {
  //       if (fieldName === 'firstName') {
  //         setfirstNameErr(false)
  //       } else {
  //         if (fieldName === 'lastName') {
  //           setlastNameErr(false)
  //         } else {
  //           if (fieldName === 'email') {
  //             setemailErr(false)
  //           }
  //         }
  //       }
  //     }
  //   }
  // }

  let reqBody = {
    ...values,
    isActive: checkbox,
    roles: rolesForSend,
    projects: personName
  }

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const handleChangeCheckbox = (event: ChangeEvent<HTMLInputElement>) => {
    setCheckbox(event.target.checked)
    event.target.checked ? setLabel('Active') : setLabel('')
  }

  const handleChangeAdmin = (event: ChangeEvent<HTMLInputElement>) => {
    setAdminRole(event.target.checked)
  }
  // const handleChangeIT = (event: ChangeEvent<HTMLInputElement>) => {
  //   setITRole(event.target.checked)
  // }
  const handleChangeServiceDesk = (event: ChangeEvent<HTMLInputElement>) => {
    setServiceRole(event.target.checked)
  }

  let isSaveButtonDisabled: boolean
  values.userName === "" || values.password === "" || values.firstName === ""
    || values.lastName === "" || values.email === ""
    || rolesForSend.length === 0 ? isSaveButtonDisabled = true : isSaveButtonDisabled = false

  const checkPassword = () => {
    if (values.password !== unconfirmedPassword) {
      setError(true)
    } else setError(false)
  }

  const createNewUser = () => {
    isNewAccount ? createNewUserforNewAccout() : createNewUserForExistAccount()
  }

async function createNewUserforNewAccout() {
  await dispatch(createNewUserForNewAccountTC({user: reqBody}))
  setCurrentLocation(`\\ Accounts \\ New Account `)
  navigate(`/accountsList/newAccount`)
}

async function createNewUserForExistAccount() {
  await dispatch(createNewUserTC({user: reqBody}))
  navigate(`/accountsList/${accountId}`, {state: {accountId}})
}

  let projectNames: Array<{projectName: string, projectId: number}> = getProjectNamesFromCookies()
  if(!projectNames){
    projectNames = [] as Array<{projectName: string, projectId: number}>
  }

  const handleChangeSelect = (event: SelectChangeEvent<typeof personName>) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };
  return (
    <>
      <Container maxWidth={false}>
        <Grid container style={{ paddingTop: '70px', paddingBottom: '50px' }} spacing={3} alignItems="center">
          <Grid item xl={10} md={10} xs={6} style={{ paddingTop: '30px' }}>
            {isNewAccount ? <Button onClick={(e) => navigate(`/accountsList/newAccount`)} color='info' className='addItemButton' startIcon={<KeyboardReturnIcon style={{ color: 'grey' }} fontSize='medium' />}>
            Back to New Account
          </Button> : 
          <Button onClick={(e) => navigate(`/accountsList/${accountId}`, {state: {accountId}})} color='info' className='addItemButton' startIcon={<KeyboardReturnIcon style={{ color: 'grey' }} fontSize='medium' />}>
          Back to account
        </Button>}
          </Grid>
          <Grid item xl={2} md={2} xs={6}>
            <Button style={{ float: 'right' }}
              color="info"
              disabled={isSaveButtonDisabled}
              variant="contained"
              onClick={checkEmptyFields}
            >
              Save
            </Button>
          </Grid>
        </Grid>
        <Box sx={{ pt: 3 }}>
          <Box>
            <form
              autoComplete="no"
              noValidate
            >
              <CardHeader
                title={`User data`}
              />
              <Divider />
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item md={12} xs={12}>
                    <TextField
                      fullWidth
                      autoComplete='new-password'
                      autoFocus
                      error={userNameErr}
                      label="User name"
                      name="userName"
                      required={true}
                      variant="outlined"
                      onChange={handleChange}
                      value={values.userName}
                    />
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-multiple-checkbox-label">Project</InputLabel>
                      <Select
                        labelId="demo-multiple-checkbox-label"
                       
                        id="demo-multiple-checkbox"
                        multiple
                        value={personName}
                        onChange={handleChangeSelect}
                        input={<OutlinedInput label="Project" />}
                        renderValue={(selected) => selected.join(', ')}
                        //MenuProps={MenuProps}
                        fullWidth
                      >
                        {projectNames.map((pr) => (
                          <MenuItem key={pr.projectId} value={pr.projectName}>
                            <Checkbox color='info' checked={personName.indexOf(pr.projectName) > -1} />
                            <ListItemText primary={pr.projectName} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      autoComplete='new-password'
                      error={passwordErr}
                      label="Password"
                      name="unconfirmedPassword"
                      type="password"
                      onChange={(event) => setUnconfirmedPassword(event.target.value)}
                      required
                      value={unconfirmedPassword}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                    style={{ position: 'relative' }}
                  >
                    <TextField
                      fullWidth
                      label="Confirm password"
                      error={err}
                      name="password"
                      type="password"
                      onChange={handleChange}
                      onBlur={checkPassword}
                      required
                      value={values.password}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      error={firstNameErr}
                      label="Name"
                      name="firstName"
                      onChange={handleChange}
                      required
                      value={values.firstName}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      error={lastNameErr}
                      label="Last name"
                      name="lastName"
                      onChange={handleChange}
                      required
                      value={values.lastName}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      error={emailErr}
                      label="Email"
                      name="email"
                      onChange={handleChange}
                      required
                      value={values.email}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      multiline
                      rows={4}
                      label="Description"
                      name="description"
                      onChange={handleChange}
                      value={values.description}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xl={3} xs={12}><Typography> Roles: </Typography></Grid>
                  <Grid item xl={9} xs={12}>
                    <FormControlLabel control={<Checkbox style={rolesErr ? { color: 'red' } : { color: '#00a0d1' }} name='Administrator' onChange={handleChangeAdmin} checked={adminRole} />} label="Administrator" />
                  </Grid>
                  <Grid
                    item
                    xl={3}
                    xs={12}>
                  </Grid>
                  {/* <Grid
                    item
                    xl={9}
                    xs={12}>
                    <FormControlLabel control={<Checkbox style={rolesErr ? { color: 'red' } : { color: 'black' }} name='IT' onChange={handleChangeIT} checked={itRole} />} label="IT" />
                  </Grid> */}
                  {/* <Grid
                    item
                    xl={3}
                    xs={12}>
                  </Grid> */}
                  <Grid
                    item
                    xl={9}
                    xs={12}>
                    <FormControlLabel control={<Checkbox style={rolesErr ? { color: 'red' } : { color:'#00a0d1' }} name='Servicedesk' onChange={handleChangeServiceDesk} checked={serviceRole} />} label="Servicedesk" />
                  </Grid>
                  <Grid
                    item
                    xl={3}
                    xs={12}><Typography> Status : </Typography>
                  </Grid>
                  <Grid
                    item
                    xl={9}
                    xs={12}>
                    <FormControlLabel control={<Switch name="isActive" color='info' checked={checkbox} onChange={handleChangeCheckbox} />} label={label} />
                  </Grid>
                </Grid>
              </CardContent>
              <Divider />
            </form>
          </Box>
        </Box>
      </Container>
    </>
  );
}

type NewUserDataPropsType = {
  isNewAccount: boolean
}
